import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { clone } from 'lodash';

import { environment } from '../../environments/environment';
import { NurseVisit } from './nurse-visit';
import { requestHeaders } from '../shared/api.service';

const camelcaseKeysDeep = require('camelcase-keys-deep');
const decamelizeKeysDeep = require('decamelize-keys-deep');

@Injectable()
export class NurseVisitService {
  baseUrl = environment.serverUrl;

  constructor(
    private http: Http
  ) { }

  getNurseVisit(nurseVisitId) {
    let nurseVisitUrl = this.baseUrl + 'nurse_visits/' + nurseVisitId + '/';

    return this.http.get(nurseVisitUrl, { headers: requestHeaders() })
      .map(this.extractData);
  }

  getNurseVisits(query: any = null): Observable<NurseVisit[]> {
    let nurseVisitUrl = this.baseUrl + 'nurse_visits/';

    return this.http.get(nurseVisitUrl, { headers: requestHeaders() })
      .map(this.extractData);
  }

  save(model) {
    let nurseVisitUrl = this.baseUrl + 'nurse_visits/';
    let params = clone(model);

    params.services = params.services && params.services.map(service => service.key);

    params = decamelizeKeysDeep(params);

    if (params && params.id) {
      nurseVisitUrl = this.baseUrl + 'nurse_visits/' + params.id + '/';
      return this.http.put(nurseVisitUrl, params, {
        headers: requestHeaders()
      }).map((res: Response) => {
        return this.extractData(res);
      });
    } else {
      return this.http.post(nurseVisitUrl, params, {
        headers: requestHeaders()
      }).map((res: Response) => {
        return this.extractData(res);
      });
    }
  }

  private extractData(res: Response) {
    let body = res.json().results;
    if (body) {
      return body.map(nurseVisit => {
        nurseVisit = camelcaseKeysDeep(nurseVisit);
        return new NurseVisit(nurseVisit);
      });
    } else if (res.json()) {
      let nurseVisit = camelcaseKeysDeep(res.json());
      return new NurseVisit(nurseVisit);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/nurse-visits/nurse-visit.service.ts